"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[973],{

/***/ 7654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ContentBoxList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4623);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6017);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);





function ContentBoxList(props) {
    var _listCss, _textCss, _listCss1, _textCss1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "z-10 relative ".concat(props.sectionCss ? props.sectionCss : ""),
        children: [
            props.style === "columns" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex  flex-col lg:flex-row gap-4 px-4 xl:px-0 ".concat((_listCss = props.listCss) !== null && _listCss !== void 0 ? _listCss : props.listCss, " items-").concat(props.boxes.length),
                children: props.boxes.map(function(entry) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "content-box rounded-[0.25rem] shadow-lg border-[1px] border-maturity bg-white overflow-hidden",
                        children: [
                            entry.photo.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "content-box-photo h-[22rem] relative z-30 text-center flex items-center justify-center box-image",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(entry.photo),
                                    objectFit: "cover",
                                    alt: entry.photo.data.attributes.alternativeText || "",
                                    quality: 80,
                                    layout: "fill",
                                    className: "object-fill"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "content-box-content block p-10 box-content",
                                children: [
                                    entry.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: "text-action block uppercase",
                                        children: entry.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block ".concat((_textCss = props.textCss) !== null && _textCss !== void 0 ? _textCss : props.textCss),
                                        dangerouslySetInnerHTML: {
                                            __html: entry.content
                                        }
                                    }),
                                    entry.buttons && entry.buttons.map(function(button) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: button.link,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                title: button.label,
                                                className: "btn mt-4  ".concat(button.style),
                                                children: button.label
                                            })
                                        }, "content-box-button-".concat(button.id));
                                    })
                                ]
                            })
                        ]
                    }, "box-entry-".concat(entry.id.toString()));
                })
            }),
            props.style === "zig-zag-list" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col gap-4 px-10 xl:px-0 ".concat((_listCss1 = props.listCss) !== null && _listCss1 !== void 0 ? _listCss1 : props.listCss),
                children: props.boxes.map(function(entry, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "content-box-zig-zag flex flex-col lg:flex-row justify-start items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "relative content-box-image z-30 flex rounded-lg  justify-start ".concat(index % 2 == 0 ? "lg:order-0" : "lg:order-2"),
                                children: entry.photo.data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(entry.photo),
                                    alt: entry.photo.data.attributes.alternativeText || "",
                                    quality: 80,
                                    width: entry.photo.data.attributes.width,
                                    height: entry.photo.data.attributes.height,
                                    objectFit: "contain",
                                    className: "rounded-lg overflow-hidden"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "content-box-content flex flex-col basis-1 md:basis-2/3 lg:basis-1/2 pt-4 lg:pt-0 lg:px-10 mb-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-trust block uppercase",
                                        children: entry.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "block ".concat((_textCss1 = props.textCss) !== null && _textCss1 !== void 0 ? _textCss1 : props.textCss),
                                        dangerouslySetInnerHTML: {
                                            __html: entry.content
                                        }
                                    }),
                                    entry.buttons && entry.buttons.map(function(button) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: button.link,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                title: button.label,
                                                className: "btn mt-4 btn-lg ".concat(button.style),
                                                children: button.label
                                            })
                                        }, "content-box-button-".concat(button.id));
                                    })
                                ]
                            })
                        ]
                    }, entry.id.toString());
                })
            })
        ]
    });
}


/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CtaBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);



function CtaBox(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "cta-box",
        children: [
            props.style === "angled-blue" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "skew-top"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "relative bg-gradient-trust",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container py-32",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "skew-bottom"
                    })
                ]
            }),
            props.style !== "angled-blue" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col w-fullrounded-[0.25rem] mx-auto cta-box ".concat(props.style),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props))
            })
        ]
    });
}
var Content = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col mx-auto  max-w-screen-xl  items-center justify-center px-4 lg:px-24 pt-8 pb-16 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: props.content
                }
            }),
            props.buttons && props.buttons.map(function(button) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: button.link,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        title: button.label,
                        className: "btn mt-4 btn-lg ".concat(button.style),
                        children: button.label
                    })
                }, "cta-button-".concat(button.id));
            })
        ]
    });
};


/***/ }),

/***/ 626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LargeBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/angle-box.jsx

function AngleBox(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-maturity-100 angle-box",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-top-full"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-top "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mt-4",
                children: props.children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-bottom-border"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-bottom"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(6017);
;// CONCATENATED MODULE: ./components/angle-box-gradient.jsx

function AngleBoxGradient(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative bg-gradient-trust",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container py-32",
                    children: props.children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "skew-bottom"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/large-box.jsx






function LargeBox(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "".concat(props.style, " py-8"),
        children: [
            (props.style === "white-text-left" || props.style === "white-text-right") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "white-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full lg:w-1/2 flex flex-col p-8 justify-center items-start ".concat(props.style === "white-text-right" ? "order-2" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            }),
                            props.buttons && props.buttons.map(function(button, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: button.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            title: button.label,
                                            className: "btn mt-4 btn-lg ".concat(button.style),
                                            children: button.label
                                        })
                                    }, "lb-button-".concat(props.id, "-").concat(button.id, "-").concat(index))
                                });
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative flex w-full lg:w-1/2 align-center photo-wrapper justify-center items-center h-96 lg:h-auto overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: props.photo.data.attributes.width,
                            height: props.photo.data.attributes.height,
                            objectFit: "cover",
                            src: (0,media/* default */.Z)(props.photo),
                            alt: props.photo.data.attributes.alternativeText || "",
                            quality: 85
                        })
                    })
                ]
            }, "large-b-".concat(props.id)),
            props.style === "dark-blue" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dark-blue-box",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full lg:w-1/2 flex flex-col p-8 justify-center items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: props.content
                                }
                            }),
                            props.buttons && props.buttons.map(function(button) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: button.link,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: button.label,
                                        className: "btn mt-4 btn-lg ".concat(button.style),
                                        children: button.label
                                    })
                                }, "lb-button-".concat(props.id, "-").concat(button.id));
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative flex w-full lg:w-1/2 align-center photo-wrapper justify-center items-center h-96 lg:h-auto overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: props.photo.data.attributes.width,
                            height: props.photo.data.attributes.height,
                            objectFit: "cover",
                            src: (0,media/* default */.Z)(props.photo),
                            alt: props.photo.data.attributes.alternativeText || "",
                            quality: 85
                        })
                    })
                ]
            }, "large-b-".concat(props.id)),
            props.style === "angled-blue" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AngleBoxGradient, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col lg:flex-row angle-box-gradient",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative flex w-full lg:w-3/5 align-center photo-wrapper justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                width: props.photo.data.attributes.width,
                                height: props.photo.data.attributes.height,
                                objectFit: "cover",
                                src: (0,media/* default */.Z)(props.photo),
                                alt: props.photo.data.attributes.alternativeText || "",
                                quality: 85
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full lg:w-2/5 flex flex-col mb-[4rem] py-8 px-8 text-left justify-center items-start z-2 lg:py-32 lg:mb-0 lg:pr-0 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                }),
                                props.buttons && props.buttons.map(function(button) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: button.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            title: button.label,
                                            className: "btn mt-4 btn-lg ".concat(button.style),
                                            children: button.label
                                        })
                                    }, "lb-button-".concat(props.id, "-").concat(button.id));
                                })
                            ]
                        })
                    ]
                })
            }, "large-b-".concat(props.id)),
            props.style === "angled-gray" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AngleBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col lg:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative bg-maturity-100 flex w-full lg:w-1/2 align-center photo-wrapper justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: props.photo.data.attributes.width,
                                    height: props.photo.data.attributes.height,
                                    objectFit: "cover",
                                    src: (0,media/* default */.Z)(props.photo),
                                    alt: props.photo.data.attributes.alternativeText || "",
                                    quality: 85
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "skew-bottom maturity-100 lg:hidden"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full lg:w-1/2 flex flex-col mb-[10rem] py-8 px-8 text-left justify-center items-start bg-maturity-100 z-2 lg:py-32 lg:mb-0 lg:pr-0 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: props.content
                                    }
                                }),
                                props.buttons && props.buttons.map(function(button) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: button.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            title: button.label,
                                            className: "btn mt-4 btn-lg ".concat(button.style),
                                            children: button.label
                                        })
                                    }, "lb-button-".concat(props.id, "-").concat(button.id));
                                })
                            ]
                        })
                    ]
                })
            }, "large-b-".concat(props.id))
        ]
    }, "section-".concat(props.id));
}


/***/ }),

/***/ 4623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Section(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: props.className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container mx-auto",
            children: props.children
        })
    });
}


/***/ }),

/***/ 3550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TestimonialList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4623);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6017);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);




function TestimonialList(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_section__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "z-10 py-8 relative testimonials ".concat(props.style ? props.style : ""),
        children: [
            props.headerContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "testimonials-title",
                dangerouslySetInnerHTML: {
                    __html: props.headerContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-wrap flex-row w-full lg:flex-row p-4 xl:px-0",
                children: props.testimonials.data.map(function(entry) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex p-4 w-full md:w-1/2 lg:w-1/3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col rounded-[0.25rem] bg-white p-8 py-16 shadow-sm",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-2/3 max-w-[10rem] aspect-square relative z-30 text-center flex items-center justify-center rounded-full overflow-hidden mx-auto ",
                                    children: entry.attributes.photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(entry.attributes.photo),
                                        objectFit: "cover",
                                        alt: entry.attributes.photo.data.attributes.alternativeText || "",
                                        quality: 80,
                                        layout: "fill",
                                        className: "object-fill"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "block p-4 box-content text-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            className: "text-black block ",
                                            children: entry.attributes.author
                                        }),
                                        entry.attributes.job_title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-black block ",
                                            children: entry.attributes.job_title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block",
                                            dangerouslySetInnerHTML: {
                                                __html: entry.attributes.content
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "testimonial-".concat(entry.id));
                })
            })
        ]
    });
}


/***/ }),

/***/ 3086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Title; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Title(props) {
    var getAlignClass = function(align) {
        switch(align){
            case "center":
                return "justify-center text-center";
                break;
            case "right":
                return "justify-end text-right";
                break;
            default:
                return "justify-start";
                break;
        }
    };
    var align = getAlignClass(props.align);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col w-full max-w-screen-xl mx-auto title-box ".concat(align, " ").concat(props.css ? props.css : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-row items-center px-4",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "w-full",
                dangerouslySetInnerHTML: {
                    __html: props.title
                }
            })
        })
    });
}


/***/ })

}]);